function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Group_4559",
  "data-name": "Group 4559",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24"
}, props), /*#__PURE__*/React.createElement("path", {
  id: "Path_2366",
  "data-name": "Path 2366",
  d: "M24 0H0v24h24z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2367",
  "data-name": "Path 2367",
  d: "M17 11.333L6.777 4.518A.5.5 0 006 4.934v14.132a.5.5 0 00.777.416L17 12.667V19a1 1 0 002 0V5a1 1 0 00-2 0z",
  transform: "translate(-1)",
  fill: "#fff"
})));